import { Controller } from "@hotwired/stimulus"

// Change Tax Rate panel on the student profile.
// Only shows/hides the panel — the address picking inside it is handled by the shared
// student-location-form controller that ships with the location widget.
export default class extends Controller {
  static targets = ["studentSection", "officeSection"];

  // Student address / pick-up point vs an office address. Only one section is submitted
  // in a meaningful way — the server reads tax_location_type to decide which fields to
  // trust, so leaving the other section's inputs in the DOM is harmless.
  toggleType(event) {
    const value = event.currentTarget.value;

    // "exempt" needs no address at all, so neither section applies.
    if (this.hasStudentSectionTarget) this.studentSectionTarget.hidden = value !== "student_address";
    if (this.hasOfficeSectionTarget) this.officeSectionTarget.hidden = value !== "office_address";
  }

  showQuickLook(event) {
    event.preventDefault();

    const panel = document.querySelector("#pupil-tax-location-quick-look");
    if (panel) {
      panel.classList.remove("u-hidden");
    }
  }

  closeQuickLook(event) {
    event.preventDefault();

    const panel = document.querySelector("#pupil-tax-location-quick-look");
    if (panel) {
      panel.classList.add("u-hidden");
    }
  }
}
